import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup-container" }
const _hoisted_2 = { class: "popup-menu" }
const _hoisted_3 = { class: "w-full bg-white shadow-sm rounded-[33px] flex flex-col items-center bg-gradiant-box-menu" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "profile-pannel" }
const _hoisted_6 = { class: "top-popup-pannel z-[999]" }

import { ref } from 'vue';
import IconLogout from '@/components/icon/IconLogout.vue';
import { Logout } from '@/stores/Logout';

interface Props {
    status: Boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePopupMenu',
  props: {
    status: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'close', payload: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    status: Boolean
};





const iconsData = ref(require('@/json/icons/icons.json'))

const dataLogout = Logout()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.status)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"])),
            class: "w-full h-screen bg-[#0000009f] flex flex-col items-center justify-center fixed top-0 left-0 z-50"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "close-popup",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  }, [
                    _createElementVNode("img", {
                      src: require('@/assets/image/icons/' + iconsData.value.close),
                      class: "w-3 h-3",
                      alt: "close"
                    }, null, 8, _hoisted_4)
                  ]),
                  _createElementVNode("div", {
                    class: "absolute left-5 top-2 cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(dataLogout).UserLogout()))
                  }, [
                    _createVNode(IconLogout)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "profile")
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "pannel")
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})